import React, { useEffect, useState } from "react";
import { CheckCircle } from "lucide-react";
import { motion } from "framer-motion";

const About = () => {
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setInView(true); // Trigger animation when in view
          }
        });
      },
      { threshold: 0.5 } // Trigger when 50% of the section is visible
    );

    const aboutSection = document.getElementById("about");
    if (aboutSection) {
      observer.observe(aboutSection);
    }

    return () => {
      if (aboutSection) {
        observer.unobserve(aboutSection);
      }
    };
  }, []);

  return (
    <section
      id="about"
      className="py-20 bg-white overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <motion.div
            className="relative"
            initial={{ opacity: 0, x: -50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <h2 className="text-4xl font-bold text-gray-900 mb-6 about-heading">
              About NS 24
            </h2>
            <p className="text-lg text-gray-700 mb-8">
              With years of experience in the construction industry, NS 24 has
              established itself as a leading provider of construction and design
              services. We combine expertise, innovation, and dedication to
              deliver exceptional results for every project.
            </p>
            <div className="space-y-4">
              {[
                "Expert Team of Professionals",
                "Quality Craftsmanship",
                "Timely Project Completion",
                "Customer Satisfaction Guaranteed",
              ].map((text, idx) => (
                <motion.div
                  key={idx}
                  className="flex items-center"
                  initial={{ opacity: 0, y: 20 }}
                  animate={inView ? { opacity: 1, y: 0 } : {}}
                  transition={{
                    duration: 0.5,
                    delay: 0.2 + idx * 0.1,
                    ease: "easeOut",
                  }}
                >
                  <CheckCircle className="w-6 h-6 text-blue-900 mr-3 about-check-icon" />
                  <span className="text-gray-700 about-check-text">{text}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>

          <motion.div
            className="relative h-96"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={inView ? { opacity: 1, scale: 1 } : {}}
            transition={{ duration: 1, ease: "easeOut" }}
          >
            <motion.img
              src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
              alt="Construction site"
              className="absolute inset-0 w-full h-full object-cover rounded-lg shadow-lg"
              initial={{ scale: 1.1 }}
              animate={inView ? { scale: 1 } : {}}
              transition={{ duration: 1, ease: "easeInOut" }}
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
